export const QuestionCircleIcon = ({ color = '#9CA3AF' }: { color?: string }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM7.00003 3.5C6.17161 3.5 5.50003 4.17157 5.50003 5C5.50003 5.27614 5.27617 5.5 5.00003 5.5C4.72389 5.5 4.50003 5.27614 4.50003 5C4.50003 3.61929 5.61932 2.5 7.00003 2.5C8.38074 2.5 9.50003 3.61929 9.50003 5C9.50003 5.99054 8.91659 6.85093 8.07163 7.26825C7.79467 7.40516 7.60876 7.62413 7.53436 7.85304C7.47174 8.04562 7.47503 8.22664 7.47503 8.3125V8.75C7.47503 9.02614 7.25117 9.25 6.97503 9.25C6.69889 9.25 6.47503 9.02614 6.47503 8.75V8.3125L6.47481 8.28003C6.47168 7.99659 6.46587 7.45857 6.58373 7.0959C6.7442 6.60228 7.10063 6.18498 7.60994 5.93353C8.14631 5.66851 8.50003 5.37422 8.50003 5C8.50003 4.17157 7.82846 3.5 7.00003 3.5ZM7 11.5C7.41421 11.5 7.75 11.1642 7.75 10.75C7.75 10.3358 7.41421 10 7 10C6.58579 10 6.25 10.3358 6.25 10.75C6.25 11.1642 6.58579 11.5 7 11.5Z"
      fill={color}
    />
  </svg>
);
